import { refreshAccessToken } from "./user.actions";

const startTokenRefreshTimer = (store) => {
  const refreshInterval = 2880 * 60 * 1000; // 2880 minutes in milliseconds

  const refreshTokens = async () => {
    const { refreshToken } = store.getState().auth;
    if (refreshToken) {
      store.dispatch(refreshAccessToken(refreshToken));
    }
    setTimeout(refreshTokens, refreshInterval); // Schedule the next refresh
  };

  setTimeout(refreshTokens, refreshInterval); // Start the timer
};

export default startTokenRefreshTimer;
